import React,{useState} from 'react'
import {Panel} from 'reactflow'
import Icon from '../../components/Text/Icon'
import Text from '../../components/Text/Text'

export default function CanvasToolbar({
    chatLoading,
    hasUnapprovedChanges,
    canUndo,
    canRedo,
    onToggleChat,
    onToggleSettings,
    onToggleNodes,
    onOpenMermaidImport,
    onOpenShortcuts,
    onAcceptAllChanges,
    onRejectAllChanges,
    onUndo,
    onRedo,
    onExportPNG,
    onExportSVG,
    onExportMermaid,
    onExportJSON,
    onImportJSON,
}) {
    const [showExport,setShowExport]=useState(false)

    return (
        <>
            <Panel position='top-right'>
                {/* Main toolbar row */}
                <div role="toolbar" aria-label="Canvas tools" className='flex flex-row justify-center items-center px-1 py-2 text-xl rounded-md shadow-md bg-light'>
                    {canUndo&&
                        <Icon
                            onClick={canUndo? onUndo:undefined}
                            className={canUndo? 'border-r cursor-pointer':'border-r opacity-30 cursor-not-allowed'}
                            icon='arrow-counterclockwise'
                            label='Undo (⌘Z)'
                            aria-disabled={!canUndo}
                        />
                    }
                    {canRedo&&
                        <Icon
                            onClick={canRedo? onRedo:undefined}
                            className={canRedo? 'border-r cursor-pointer':'border-r opacity-30 cursor-not-allowed'}
                            icon='arrow-clockwise'
                            label='Redo (⌘⇧Z)'
                            aria-disabled={!canRedo}
                        />
                    }
                    <Icon onClick={onToggleChat} className={chatLoading? 'border-r animate-pulse cursor-pointer':'border-r cursor-pointer'} label='Chat with Flowsage AI' icon='chat-left-text' />
                    <Icon className='border-r cursor-pointer' onClick={onOpenMermaidImport} icon='diagram-3' label='Import from Mermaid' />

                    {/* Export dropdown */}
                    <div className='relative border-r'>
                        <Icon className='cursor-pointer' onClick={() => setShowExport(v => !v)} icon='download' label='Export / Import' />
                        {showExport&&(
                            <div className='flex overflow-hidden absolute right-0 top-full z-50 flex-col mt-1 w-40 text-sm rounded-md border shadow-lg bg-light border-dark-100 animate-slide-up'>
                                <button onClick={() => {onExportPNG(1); setShowExport(false)}} className='px-3 py-2 text-left transition-colors hover:bg-dark-50'>PNG (1×)</button>
                                <button onClick={() => {onExportPNG(2); setShowExport(false)}} className='px-3 py-2 text-left transition-colors hover:bg-dark-50'>PNG (2×)</button>
                                <button onClick={() => {onExportPNG(4); setShowExport(false)}} className='px-3 py-2 text-left transition-colors hover:bg-dark-50'>PNG (4×)</button>
                                <button onClick={() => {onExportSVG(); setShowExport(false)}} className='px-3 py-2 text-left transition-colors hover:bg-dark-50'>SVG</button>
                                <button onClick={() => {onExportMermaid(); setShowExport(false)}} className='px-3 py-2 text-left transition-colors hover:bg-dark-50'>Mermaid (.mmd)</button>
                                <button onClick={() => {onExportJSON(); setShowExport(false)}} className='px-3 py-2 text-left transition-colors hover:bg-dark-50'>JSON</button>
                                <label className='px-3 py-2 text-left transition-colors cursor-pointer hover:bg-dark-50'>
                                    Import JSON
                                    <input type='file' accept='.json' className='hidden' onChange={e => {if(e.target.files[0]) {onImportJSON(e.target.files[0]); setShowExport(false)} }} />
                                </label>
                            </div>
                        )}
                    </div>

                    <Icon className='border-r cursor-pointer' onClick={onToggleSettings} icon='gear' label='Project Settings' />
                    <Icon className='cursor-pointer' onClick={onOpenShortcuts} icon='question-circle' label='Keyboard Shortcuts (?)' />
                </div>

                {hasUnapprovedChanges&&(
                    <div role="group" aria-label="Review AI changes" className='flex flex-row justify-center items-center px-2 py-2 mt-2 text-xl rounded-md shadow-md bg-light'>
                        <Text className='flex-1 text-xs font-semibold text-left lg:text-sm'>Accept Changes?</Text>
                        <Icon onClick={onAcceptAllChanges} aria-label='Accept all AI changes' className='flex ml-2 !p-1 !px-2 rounded-md border-r cursor-pointer aspect-square bg-success-300 text-success-700 items-center justify-center hover:bg-success-400 transition-colors hover:text-success-800' icon='check' />
                        <Icon onClick={onRejectAllChanges} aria-label='Reject all AI changes' className='flex ml-2 !p-1 !px-2 rounded-md border-r cursor-pointer aspect-square bg-danger-300 text-danger-700 items-center justify-center hover:bg-danger-400 transition-colors hover:text-danger-800' icon='x' />
                    </div>
                )}
            </Panel>
            <Panel position='top-left'>
                <div className='flex flex-col justify-center items-center p-2 px-0 text-xl rounded-md shadow-md bg-light'>
                    <Icon onClick={onToggleNodes} className='cursor-pointer' icon='plus-circle' labelPosition='right' label='Add Node' />
                </div>
            </Panel>
        </>
    )
}
